// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerAddressFormSharedStyle } from "@bg/App/SharedStyles/OnePageCheckout/CustomerAddressFormSharedStyle";
import { xScreen } from "@bg/XDL/Utilities";
import { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { BillingAddressFormStyles } from "@insite/content-library/Widgets/OnePageCheckout/BillingAddressForm";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface OnePageCheckoutAddressSectionSharedStyles {
    container?: InjectableCss;
    titleContainer?: InjectableCss;
    heading?: TypographyPresentationProps;
    addressForm?: BillingAddressFormStyles;
    addressInfoDisplay?: AddressInfoDisplayStyles;
    actionContainer?: InjectableCss;
    saveAddressButton?: ButtonPresentationProps;
    cancelEditButton?: ButtonPresentationProps;
    editAddressLink?: LinkPresentationProps;
}

const onePageCheckoutAddressSectionSharedStyles: OnePageCheckoutAddressSectionSharedStyles = {
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 12px;
        `,
    },
    titleContainer: {
        css: css`
            display: flex;
            align-items: center;
            gap: 8px 20px;
            flex-wrap: wrap;
        `,
    },
    heading: {
        variant: "h5",
        css: css`
            margin-bottom: 0;
        `,
    },
    addressForm: {
        ...customerAddressFormSharedStyle,
    },
    addressInfoDisplay: {
        wrapper: {
            css: css`
                margin-top: 0;
            `,
        },
    },
    actionContainer: {
        css: css`
            margin-top: 16px;
            display: flex;
            gap: 16px;
            ${xScreen("lte", 375)} {
                flex-direction: column;
            }
        `,
    },
    saveAddressButton: {
        sizeVariant: "small",
        css: css`
            white-space: nowrap;
            &.full-width {
                width: 100%;
            }
            ${xScreen("lte", "sm")} {
                width: 100%;
            }
        `,
    },
    cancelEditButton: {
        sizeVariant: "small",
        variant: "secondary",
        css: css`
            width: 100%;
        `,
    },
    editAddressLink: {
        css: css`
            margin-top: 16px;
        `,
    },
};

export default onePageCheckoutAddressSectionSharedStyles;
